// LLM generated - Model Claude 4 Sonnet
import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
  container: {
    // Use dvh (dynamic viewport height) to account for mobile keyboard
    // Falls back to vh for browsers that don't support dvh
    height: '100dvh',
    bottom: 'auto',
    '@supports not (height: 100dvh)': {
      height: '100vh',
    },

    [theme.fn.largerThan('sm')]: {
      height: 'auto',
    },
  },
  body: {
    width: '100vw',

    [theme.fn.largerThan('sm')]: {
      maxWidth: 420,
    },
    [theme.fn.smallerThan('sm')]: {
      // to handle android overlay when keyboard is open, separate from the viewport size change
      paddingBottom: theme.other.spacing._48 + theme.other.spacing._8,
    },
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._32,
  },
  headerSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._24,
  },
  iconWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    paddingTop: theme.other.spacing._16,
    paddingBottom: theme.other.spacing._8,
  },
  title: {
    textAlign: 'center',
  },
  subtitle: {
    textAlign: 'center',
  },
  formWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._32,
  },
}));
